import { SearchOnlyAviaPackagesResponse } from '@appTypes/api.types';
import { ValuesOfConst } from '@core/misc/utils-types.misc';
import { AVIA_TYPES_STATIC_DATA } from './avia-page.const';

export type SearchOnlyAviaPackagePaging = Pick<SearchOnlyAviaPackagesResponse, 'pageNumber' | 'pagingId'>;
export type AviaFilterStopsType = null | 'nonstop' | '1stop';

export type FlightType = (typeof AVIA_TYPES_STATIC_DATA)[0];
export type FlightTicketTypeValues = ValuesOfConst<typeof AVIA_TYPES_STATIC_DATA>['value'];
export type FilterFlightType = Exclude<FlightTicketTypeValues, 'multipleFlights'>;

/** Form-only fields persisted in `avia.searchForm` next to the API request */
export interface AviaSearchFormExtraParams {
  _flightTicketType?: FlightTicketTypeValues | null;
  /** The ticked classes (docs features/website/avia-class-multi-select R-CM1); `ticketType` is always the first of them. Website only - never sent. */
  ticketTypes?: TicketTypesEnum[] | null;
}

export enum TicketTypesEnum {
  First = 'F',
  Business = 'B',
  Premium = 'P',
  Coach = 'C' // @note - C === Economy
}
